import { DayPreference } from './day-preference.model';
import { TruckTypePreference } from './truck-type-preference.model';

export class Preferences {
    id: string;
    truckType: TruckTypePreference;
    day: DayPreference;
}
